import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { trackByRef } from 'src/app/lego-utils';
import { filter, Subscription } from 'rxjs';
import { isDefined } from 'src/app/helpers';
import { SapEnvironment } from 'src/app/models';
import { SessionService } from 'src/app/state';

@Component({
  selector: 'em-environment-selector',
  styleUrls: ['./environment-selector.component.less'],
  templateUrl: './environment-selector.component.html',
  standalone: false,
})
export class EnvironmentSelectorComponent implements OnInit, OnDestroy {
  public isCollapsed$ = this.sessionService.sideMenuIsCollapsed$;
  public readonly trackByRef = trackByRef;

  public readonly sapEnvironmentValues = Object.values(SapEnvironment);

  public readonly isDevOrLocal = this.sessionService.isDevOrLocal();
  public readonly sapEnvironmentControl: FormControl<SapEnvironment | null>;

  private readonly subscriptions = new Subscription();

  public constructor(private readonly sessionService: SessionService) {
    this.sapEnvironmentControl = new FormControl<SapEnvironment | null>(
      this.sessionService.getSelectedSapEnvironment()
    );
  }

  public ngOnInit(): void {
    this.subscriptions.add(
      this.sapEnvironmentControl.valueChanges
        .pipe(
          filter(isDefined) // no explicit null check here
        )
        .subscribe((value) => {
          this.sessionService.setSelectedSapEnvironment(value);
        })
    );
  }

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
